module.exports = __webpack_public_path__ + "img/info-icon.840b51de.svg";